module.exports = __webpack_public_path__ + "static/kiteboardingrules-12411ee5fc366b92d60a07d1b9d1f489.jpg";